import React from "react";
import LeadForm from "./LeadForm";

const NewLead = () => {
  return (
    <LeadForm title="New Lead" />
  )
};

export default NewLead;